import * as Variant from './studentLecture.variant'

export const StudentLecture = {
  ...Variant,
}

export type * as StudentLectureDtoT from './studentLecture.dto'
export type * as StudentLectureVariantT from './studentLecture.variant'
